import React,{useEffect} from "react";
import PublicacionesRecientes from "./PublicacionesRecientes";
import MasLeido from "./MasLeido";
import MasConsultado from "./MasConsultado";
import DeInteres from "./DeInteres";
import SitiosAfines from "./SitiosAfines";
import normatecaStore from "../../../stores/normatecaStore";

export default function Inicio(){
   const {setError} =
    normatecaStore((state) =>( { 
        setError: state.setError,
     })); 
       useEffect(() => {
             // setError().catch(null);
            }, []);
    return(
        <div className="inicio">
            <div className="txtBien">Bienvenido a la Normateca Institucional, medio de difusión donde encontrarás el marco jurídico y normativo vigente que rige la operación y funcionamiento del INEGI. ¡Infórmate y conoce!</div>
            <div>
                <PublicacionesRecientes/>
            </div>
           <div>
                <DeInteres/>
            </div>
            <div>
                <MasConsultado/>
            </div>
            <div>
                <MasLeido/>
            </div>
             <div>
                <SitiosAfines/>
            </div> 
        </div>
    )
}